<ng-container *ngIf="isLoaded()">
              
  <button mat-icon-button [ngSwitch]="worstResult" (click)="showAssetValidationDetails = true" cdkOverlayOrigin #trigger="cdkOverlayOrigin" matTooltip="Show Asset Validation Result">
    <mat-icon *ngSwitchCase="ruleResult.Success" class="success-button">check_circle</mat-icon>
    <mat-icon *ngSwitchCase="ruleResult.Warning" class="warning-button">warning</mat-icon>
    <mat-icon *ngSwitchCase="ruleResult.Failure" class="failure-button">dangerous</mat-icon>
    <mat-icon *ngSwitchDefault class="success-button">check_circle</mat-icon>
  </button>

  <ng-template
    cdkConnectedOverlay
    [cdkConnectedOverlayOrigin]="trigger"
    [cdkConnectedOverlayOpen]="showAssetValidationDetails"
    [cdkConnectedOverlayHasBackdrop]="true"
    [cdkConnectedOverlayBackdropClass]="'asset-validation-overlay-backdrop'"
    (backdropClick)="showAssetValidationDetails = false"
  >
    <mat-card class="asset-validation-overlay">
      <mat-card-content fxLayout="column" fxLayoutGap="10px">

        <div *ngFor="let assetValidationRule of assetValidation">
          <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px">
            <ng-container [ngSwitch]="assetValidationRule.value.result">
              <mat-icon *ngSwitchCase="ruleResult.Success" class="success-button">check_circle</mat-icon>
              <mat-icon *ngSwitchCase="ruleResult.Warning" class="warning-button">warning</mat-icon>
              <mat-icon *ngSwitchCase="ruleResult.Failure" class="failure-button">dangerous</mat-icon>
              <mat-icon *ngSwitchDefault class="info-button">info</mat-icon>
            </ng-container>
            
            <div>
              <div>{{ assetValidationRule.key }}: {{ assetValidationRule.value.value }}{{ assetValidationRule.value.valueUnit }}</div>
              <small *ngIf="assetValidationRule.value.reason">{{ assetValidationRule.value.reason }}</small>
            </div>
          </div>
        </div>
      </mat-card-content>
    </mat-card>
  </ng-template>

</ng-container>

<ng-container *ngIf="!isLoaded()">
  <button *ngIf="!isLoading()" mat-icon-button color="accent" (click)="loadAssetValidation(true)" matTooltip="Validate Asset">
    <mat-icon>image_search</mat-icon>
  </button>
  <button *ngIf="isLoading()" mat-icon-button>
    <mat-icon class="loading-button">cached</mat-icon>
  </button>
</ng-container>